import React from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { reverse } from 'named-urls';
import { Input, Button, Form } from 'antd';
import routes from '@achievable-me/tundra-wizard/routes';
import { Redirect } from 'react-router-dom';
import logoSrc from '$assets/logoWithText.png';
import { gql } from '@apollo/client';
import styles from './styles.scss';

const ACCESS_CODE = gql`
  query AccessCode($input: AccessCodeInput!) {
    accessCode(input: $input) {
      accessCode {
        uuid
        code
        slug
        redeemedAt
      }
    }
  }
`;

const ContactSupport = () => {
  return (
    <div>
      <div className={styles.contactUs}>Need help?</div>
      <div className={styles.contactMethod}>
        <b>Call/text:</b> 415-831-7733
      </div>
      <div className={styles.contactMethod}>
        <b>Email:</b>{' '}
        <a href="mailto:support@achievable.me" target="_blank" rel="noopener noreferrer">
          support@achievable.me
        </a>
      </div>
    </div>
  );
};

const AccessCodeDisplay = (props) => {
  const { data } = props;
  if (!data) {
    return null;
  }
  const {
    accessCode: { accessCode },
  } = data;
  if (!accessCode) {
    return (
      <div>
        <div className={styles.error}>Code not found</div>
        <ContactSupport />
      </div>
    );
  }

  const { code, slug, redeemedAt } = accessCode;
  if (redeemedAt) {
    return (
      <div>
        <div className={styles.error}>Code has already been redeemed</div>
        <ContactSupport />
      </div>
    );
  }

  const to = `${reverse(routes.study.purchase, { productSlug: slug })}#p=A-${code}`;
  return <Redirect to={to} push />;
};

const Redeem = () => {
  const [getAccessCode, { loading, data }] = useLazyQuery(ACCESS_CODE);

  const onFinish = async (values) => {
    const { code } = values;
    getAccessCode({ variables: { input: { code } } });
  };

  return (
    <div>
      <img className={styles.logo} src={logoSrc} />
      <div className={styles.title}>Enter access code (hidden by peel-off area)</div>
      <Form onFinish={onFinish}>
        <Form.Item
          name="code"
          rules={[{ required: true, message: 'Please enter your access code' }]}
        >
          <Input
            data-aaa="accessCode"
            prefix={<i className="fal fa-key" />}
            placeholder="XXXX   XXXX   XXXX"
            disabled={loading}
          />
        </Form.Item>
        <Form.Item>
          <Button
            data-aaa="accessCodeSubmit"
            type="primary"
            htmlType="submit"
            block
            loading={loading}
          >
            Redeem
          </Button>
        </Form.Item>
      </Form>
      <AccessCodeDisplay data={data} />
    </div>
  );
};

export default Redeem;
